/**
 * LMS - Point 8: open one LMS admit card as a printable window.
 *
 * The same markup the student portal prints (Student/Lms/Exams.js), so an admit
 * card looks identical wherever it is opened - student, council, centre or B2B.
 */
export function openLmsAdmitCard(a) {
  if (!a) return false;
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return false;
  const row = (k, v) =>
    `<tr><td style="padding:6px 10px;border:1px solid #ccc;font-weight:600;width:40%">${k}</td><td style="padding:6px 10px;border:1px solid #ccc">${v || "-"}</td></tr>`;
  w.document.write(`
    <html><head><title>Admit Card ${a.admit_no || ""}</title></head>
    <body style="font-family:Arial,sans-serif;padding:24px;color:#111">
      <h2 style="text-align:center;margin:0 0 4px">NSVEC - Admit Card</h2>
      <p style="text-align:center;margin:0 0 16px">National Skill &amp; Vocational Education Council</p>
      <table style="border-collapse:collapse;width:100%">
        ${row("Admit No.", a.admit_no)}
        ${row("Name", a.student && a.student.name)}
        ${row("Roll Number", a.student && a.student.roll_number)}
        ${row("Date of Birth", a.student && a.student.dob)}
        ${row("Course", a.course)}
        ${a.semester ? row("Semester", a.semester) : ""}
        ${row("Subject", a.subject)}
        ${row("Centre", a.center)}
        ${row("Exam", a.exam && a.exam.title)}
        ${row("Exam Date", a.exam && a.exam.date)}
        ${a.exam && a.exam.time ? row("Reporting Time", a.exam.time) : ""}
        ${row("Duration", a.exam ? a.exam.duration_minutes + " minutes" : "")}
        ${row("Total Questions", a.exam && a.exam.total_questions)}
        ${row("Passing", a.exam ? a.exam.passing_percent + "%" : "")}
      </table>
      <p style="margin-top:28px">Signature: ____________________</p>
      <script>window.onload=function(){setTimeout(function(){window.print();},300);}</script>
    </body></html>`);
  w.document.close();
  return true;
}
